import matchMediaConst from "constant/matchmedia";
import useMediaQuery from "./useMediaQuery";

function useScreenSize() {
  const isTablet = useMediaQuery({
    minWidth: matchMediaConst.SM_MIN,
    maxWidth: matchMediaConst.SM_MAX,
  });
  const isDesktop = useMediaQuery({
    minWidth: matchMediaConst.MD_MIN,
  });
  const isMobile = useMediaQuery({
    maxWidth: matchMediaConst.XS_MAX,
  });
  // eslint-disable-next-line no-nested-ternary
  const screen = isDesktop ? "isDesktop" : isMobile ? "isMobile" : "isTablet";
  return [isMobile, isTablet, isDesktop, screen] as [boolean, boolean, boolean, string];
}

export function useCustomScreenSize(matcher) {
  return useMediaQuery(matcher);
}

export default useScreenSize;
